import { jsx as _jsx } from "react/jsx-runtime";
import { IMAGES } from "../images";
export var KSpinnerSize;
(function (KSpinnerSize) {
    KSpinnerSize["nm"] = "";
    KSpinnerSize["lg"] = "fa-2x";
    KSpinnerSize["xl"] = "fa-3x";
    KSpinnerSize["xxl"] = "fa-4x";
})(KSpinnerSize || (KSpinnerSize = {}));
const mapSize = {
    [KSpinnerSize.nm]: 30,
    [KSpinnerSize.lg]: 60,
    [KSpinnerSize.xl]: 120,
    [KSpinnerSize.xxl]: 230,
};
export const KSpinner = ({ size = "", variant, theme }) => {
    if (variant) {
        return _jsx("img", { src: IMAGES[variant].animated[theme || "default"], alt: "spinner", className: `spinner`, width: mapSize[size || KSpinnerSize.nm] });
    }
    else {
        return _jsx("li", { className: `fal fa-spin fa-spinner-third ${size}` });
    }
};
